import React, { useState } from 'react';
import ReactSlider from 'react-slider';
import { Smile, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import apiClient from '../../utils/api';
import './MoodDialog.css';

function MoodDialog({ frequencyId, frequencyName, onClose }) {
  const { t } = useTranslation();
  const [moodValue, setMoodValue] = useState(5);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await apiClient.logMood(frequencyId, moodValue);
      onClose(true);
    } catch (error) {
      console.error('Error logging mood:', error);
      alert(t('moodDialog.errorSaving'));
    } finally {
      setSubmitting(false);
    }
  };

  const getMoodEmoji = (value) => {
    if (value <= 2) return '😟';
    if (value <= 4) return '😐';
    if (value <= 6) return '🙂';
    if (value <= 8) return '😊';
    return '😄';
  };

  const getMoodLabel = (value) => {
    if (value <= 2) return t('moodDialog.labels.notGood');
    if (value <= 4) return t('moodDialog.labels.soSo');
    if (value <= 6) return t('moodDialog.labels.okay');
    if (value <= 8) return t('moodDialog.labels.good');
    return t('moodDialog.labels.veryGood');
  };

  return (
    <div className="mood-dialog-overlay" data-testid="mood-dialog-overlay">
      <div className="mood-dialog" data-testid="mood-dialog">
        <button
          className="mood-dialog-close"
          onClick={() => onClose(false)}
          data-testid="mood-dialog-close-button"
        >
          <X size={20} />
        </button>

        <div className="mood-dialog-icon">
          <Smile size={48} />
        </div>

        <h2 className="mood-dialog-title">{t('moodDialog.title')}</h2>
        <p className="mood-dialog-subtitle">
          {t('moodDialog.after')} <span className="frequency-name">{frequencyName}</span>
        </p>

        <div className="mood-display">
          <div className="mood-emoji">{getMoodEmoji(moodValue)}</div>
          <div className="mood-label">{getMoodLabel(moodValue)}</div>
          <div className="mood-value">{moodValue} / 10</div>
        </div>

        <div className="mood-slider-container">
          <span className="mood-slider-label">1</span>
          <ReactSlider
            className="mood-slider"
            thumbClassName="mood-slider-thumb"
            trackClassName="mood-slider-track"
            min={1}
            max={10}
            value={moodValue}
            onChange={setMoodValue}
            data-testid="mood-slider"
          />
          <span className="mood-slider-label">10</span>
        </div>

        <div className="mood-dialog-actions">
          <button
            className="mood-button mood-button-skip"
            onClick={() => onClose(false)}
            data-testid="mood-skip-button"
          >
            {t('common.skip')}
          </button>
          <button
            className="mood-button mood-button-submit"
            onClick={handleSubmit}
            disabled={submitting}
            data-testid="mood-submit-button"
          >
            {submitting ? t('moodDialog.saving') : t('common.save')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default MoodDialog;